import { render, staticRenderFns } from "./CreateReportForm.vue?vue&type=template&id=72010b1e&scoped=true&"
import script from "./CreateReportForm.vue?vue&type=script&lang=js&"
export * from "./CreateReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72010b1e",
  null
  
)

export default component.exports